import React from 'react'

import Assets from '@lib/Assets'


export default class ImportFile extends React.Component {
    constructor(props) {
        super(props)
        this.hiddenInputRef = React.createRef();
        this.state = {
            fileName: '',
        }
    }

    onDropZoneClick = (e) => {

        e.preventDefault();
        if (this.hiddenInputRef.current) {
            this.hiddenInputRef.current.click();
        }
    }

    handleHiddenFileInputChange = (e) => {
        let file = e.target.files[0];
        let fileName = '';
        if (file) {
            fileName = file.name;
            this.setState({fileName: fileName})
        }
        if (this.props.onFileUploaded)
            this.props.onFileUploaded(file);
    }

    renderFilledBody = () => {
        let fileNames = [this.state.fileName];

        return (<div className="files-result">
            <div className="files-result header">
                {__("Files to import:")}
            </div>
            {fileNames.map(f => <div className="files-result item"> {'> ' + f + ' <'}  </div>)}

        </div>)

    }


    render() {

        return (

            <React.Fragment>
                <div className="import-file-container">
                    <div className="upload-drop-zone"
                         onClick={this.onDropZoneClick}
                         onChange={this.handleHiddenFileInputChange}
                    >
                        {this.state.fileName === '' ? __('Drag and drop file or click to browse from disk.') : this.renderFilledBody()}
                    </div>
                </div>
                < input type="file" ref={this.hiddenInputRef} onChange={this.handleHiddenFileInputChange}
                        hidden={true}></input>
            </React.Fragment>
        )

    }

}